export default __webpack_public_path__ + "static/media/digitalVoiceRecorder.64000114.svg";